@if (canView()) {
    <app-statistics-in-progress></app-statistics-in-progress>

    <app-statistics-summary-charts [summary]="summary"
                                   [loading]="summaryLoading">
    </app-statistics-summary-charts>

    <app-data-table title="Pipeline statistics"
                    [columns]="columns"
                    [fetchDataFn]="loadData"
                    [exportDataFn]="exportData"
                    [enableGlobalSearch]="true"
                    [globalFilterFields]="['state', 'year']"
                    globalSearchPlaceholder="Search by state or year"
                    defaultSortField="state"
                    defaultSortOrder="asc"
                    [scrollHeightOffsetRem]="36"
                    [exportable]="authService.hasPermission(exportPermission)">
    </app-data-table>
} @else {
    <div class="card p-4 text-color-secondary">
        You do not have permission to view pipeline statistics.
    </div>
}

<ng-template #countCell let-row="row" let-column="column">
    @if (row[column.field] == null) {
        <span class="text-color-secondary text-sm">N/A</span>
    } @else {
        <span>{{ row[column.field] | number }}</span>
    }
</ng-template>

<ng-template #ratesCell let-row="row">
    <div class="flex flex-column gap-2 py-1" style="min-width: 12rem">
        <div class="flex align-items-baseline justify-content-between gap-2"
             [pTooltip]="'Total distinct rates: ' + row.distinct_rates"
             tooltipPosition="top">
            <span class="text-xs font-bold uppercase text-primary">Total</span>
            <span class="text-sm font-bold text-primary">{{ row.distinct_rates | number }}</span>
        </div>

        @if (row.distinct_rates > 0) {
            <div class="flex w-full border-round overflow-hidden surface-200"
                 style="height: 0.5rem"
                 [pTooltip]="ratesStackTooltip(row)"
                 tooltipPosition="top">
                <div class="h-full bg-green-500" [style.width.%]="segmentPercent(row.hourly_rates, row.distinct_rates)">
                </div>
                <div class="h-full bg-orange-500" [style.width.%]="segmentPercent(row.daily_rates, row.distinct_rates)">
                </div>
                <div class="h-full bg-sky-400" [style.width.%]="segmentPercent(row.other_rates, row.distinct_rates)">
                </div>
            </div>
        } @else {
            <div class="w-full border-round surface-200"
                 style="height: 0.5rem"
                 pTooltip="No rates loaded"
                 tooltipPosition="top">
            </div>
        }

        @for (segment of rateSegments(row); track segment.key) {
            <div class="flex align-items-center gap-2"
                 [pTooltip]="segment.tooltip"
                 tooltipPosition="top">
                <span class="text-xs font-semibold flex-shrink-0"
                      style="width: 2.75rem"
                      [ngClass]="segment.labelClass">
                    {{ segment.label }}
                </span>
                <div class="flex-1 border-round overflow-hidden surface-200"
                     style="height: 0.45rem">
                    <div class="h-full border-round"
                         [ngClass]="segment.barClass"
                         [style.width.%]="segment.percent">
                    </div>
                </div>
                <span class="text-xs font-bold text-right flex-shrink-0"
                      style="width: 2.5rem">
                    {{ segment.value | number }}
                </span>
            </div>
        }
    </div>
</ng-template>
